import { DresonRuleResolvedEvent } from "../../types/FilterTypes";
import { current as currentSelection } from "@otto-ec/nexus-registry/selection";
import type { SelectionState } from "@otto-ec/nexus-registry/selection";
import { eventQBus } from "../../types/EventQBus";
import { toggles } from "../utils/Toggles";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export class TopicPageFilterHandler {
  private readonly originalSelektion: string | null;

  constructor(private readonly navigationHistoryEnabled = toggles.isActive("REPTILE_1303_NAVIGATION_HISTORY")) {
    this.originalSelektion = new URLSearchParams(window.location.search).get("selektion");
  }

  init(selectionEventsEnabled = toggles.isActive("REPTILE_1147_NEXUS_SELECTION")): void {
    if (selectionEventsEnabled) {
      currentSelection.on((selection) => this.onResolved(selection));
      return;
    }

    eventQBus.on("ftfind.dresonRule.resolved", (event: DresonRuleResolvedEvent) => this.onResolved(event));
  }

  isTopicPage(): boolean {
    return document.documentElement.dataset.pagecluster === "Themenseite";
  }

  onResolved(event: Pick<SelectionState, "rule">): void {
    if (this.navigationHistoryEnabled || !this.isTopicPage()) {
      return;
    }
    const url = this.buildUrl(event.rule);
    eventQBus.emit("ftfind.history.push", { url });
  }

  buildUrl(resolvedRule: string): string {
    const search = window.location.search;
    const isFiltered = resolvedRule !== this.originalSelektion;
    const filteredParam = `filtered=${encodeURIComponent(resolvedRule)}`;

    /**
 *
 *
 *
 *
 *
 */
    const withoutFiltered = search.replace(/([?&])filtered=[^&]*(&|$)/, (_, prefix, suffix) => (suffix ? prefix : ""));
    const separator = withoutFiltered.includes("?") ? "&" : "?";
    const newSearch = isFiltered ? withoutFiltered + separator + filteredParam : withoutFiltered;
    return window.location.pathname + newSearch;
  }
}
